import { CommonModalProps } from '../../../../lib/types/aemDataModels';
import { useViewContext } from '../../../../lib/context/ViewContext';
import AssignTrainingDialog from '../../base/AssignTrainingDialog/AssignTrainingDialog';
import { useUserAssignCourse, useUserAssignLp } from '../../../../lib/api/postApi';

const TeamMemberAssignTrainingDialog = (props: CommonModalProps) => {
  const {
    page: { memberId },
  } = useViewContext();

  const assignCourse = useUserAssignCourse(memberId ?? '');
  const assignLearningPath = useUserAssignLp(memberId ?? '');

  if (!memberId) {
    return null;
  }

  return (
    <AssignTrainingDialog
      {...props}
      assignCourse={assignCourse}
      assignLp={assignLearningPath}
      params={{ excludeAssignedToUserId: memberId }}
    />
  );
};

export default TeamMemberAssignTrainingDialog;
